import { Ref } from "vue";
import { Constructor } from "../@types/shared";

import {
    DoorCode,
    OverdoorCode,
    DividerPartitionCode,
    GlassPartitionCode,
} from "../constants";
import { ICreateOneStrategy } from "../domain/strategies/base/creation.strategy";
import { DeliveryDividerCreationStrategy, DeliveryGlassPartitionCreationStrategy, DeliveryDoorCreationStrategy, DeliveryOverdoorCreationStrategy } from "../domain/strategies/creation/delivery.strategy";

export class DeliveryStrategiesRegistry {
    private strategies = new Map<string, Constructor<ICreateOneStrategy>>();

    constructor() {
        this.register(DividerPartitionCode, DeliveryDividerCreationStrategy);  // div -> Divider element
        this.register(GlassPartitionCode, DeliveryGlassPartitionCreationStrategy);  // fxp -> GlassPartition element
        this.register(DoorCode, DeliveryDoorCreationStrategy);  // dr -> Door element
        this.register(OverdoorCode, DeliveryOverdoorCreationStrategy);  // filler -> Overdoor filler element
    }

    getStrategy = (
        elementType: Ref<string> | string,
    ): Constructor<ICreateOneStrategy> | null => {
        if (!elementType) return null;
        const key = typeof elementType === "object" && "value" in elementType ? elementType.value : elementType;
        return this.strategies.get(key) || null;
    };

    private register = (
        elementType: string,
        strategy: Constructor<ICreateOneStrategy>,
    ) => {
        this.strategies.set(elementType, strategy);
    };
}
